import type { ExplicitAddress } from '@cronos-app/sdk';
import type { NormalToken, Token } from '@ui/config/token/types';
import type { Fraction } from 'bi-fraction';

export type TokenOption =
  | NormalToken
  | BondingTokenWithAddress
  | AgentTokenWithAddress;

export interface BondingTokenWithAddress {
  type: Token.Bonding;
  bondingAddress: ExplicitAddress;
}

export interface AgentTokenWithAddress {
  type: Token.Agent;
  agentAddress: ExplicitAddress;
}

export function isBondingToken(
  token: TokenOption,
): token is BondingTokenWithAddress {
  return typeof token === 'object' && 'bondingAddress' in token;
}

export function isAgentToken(
  token: TokenOption,
): token is AgentTokenWithAddress {
  return typeof token === 'object' && 'agentAddress' in token;
}

export function isNormalToken(token: TokenOption): token is NormalToken {
  return typeof token === 'string';
}

export interface TokenPriceFetcher {
  fetchPrice: (token: TokenOption) => Promise<{
    usd_price: Fraction;
    usd_price_change_24h: Fraction;
  }>;
  supportsToken: (token: TokenOption) => boolean;
}
